/**
 * @format
 */
// Migrated from AngularJS: studentProfile.service.js
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OtmId, PrivatePerson } from 'common-typescript/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonNameService } from 'sis-components';

export type StudentProfile = PrivatePerson & { fullName: string; fullNameReversed: string };

@Injectable({
    providedIn: 'root',
})
export class StudentProfileService {
    private readonly url = '/ori/api/user-details';

    constructor(
        private http: HttpClient,
        private personNameService: PersonNameService,
    ) {}

    profile(): Observable<StudentProfile> {
        return this.http.get<PrivatePerson>(this.url).pipe(map(person => this.enrichWithName(person)));
    }

    saveLimitedStudentBasicInfo(profile: PrivatePerson): Observable<StudentProfile> {
        return this.http.put<PrivatePerson>(this.url, profile).pipe(map(person => this.enrichWithName(person)));
    }

    grantGraduationSurveyExemption(planId: OtmId): Observable<void> {
        return this.http.post<void>(`${this.url}/graduation-survey-exemption`, null, { params: { planId } });
    }

    private enrichWithName(person: PrivatePerson): StudentProfile {
        return {
            ...person,
            fullName: this.personNameService.getFullName(person),
            fullNameReversed: this.personNameService.getFullNameReversed(person),
        };
    }
}
